var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "url(#pattern0_2_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2_3",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2_3",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2_3",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB00lEQVR4nO2YTU7DMBBGXUq7ZwMqcAO4T1dILACp5RK9EUIcACT+WsFpKF0h8VCkLBo3JE5t5we+t53Kk3kZj6YxRgghhBCiImxJhOf4tlL0QufIRQK2xAQC2AUuclKcJ7FQeVopANgH5gVpnpLfhMhVGWAMfMUSAPSBewfXL8DQN1/Q4gMJmOLOlW8+3+I3ZATIs7COvAOOgEPg1ootfPP5Fj+OIGBlHXm8FkskrLPyzedVfBoPLeDjNwG1Q0nxkQQkw23jCngXE6P4SAIm5LMEntMhOfDNE6T4SAIGwBvFvAMj31zexccQkJ45cpQwbLT4WALWOmGStn3S/nlMGy2+TtJdwN4DXv9F8QV7wNL4ApzWWXzZlQE+CxahZDaEX4SAWV1v3kHAvGAVvrFiDyEfbFZH2zsIuMady9APdxL0wO0EuOwBpBtj33QNSgSkvzko+SDyCOyZLoKDgJJPYmfAjukqOApo/KtwLP68AEoKrCqgcyABWaoK6jxIQBZfQfbQa/1QRAKy+ApSB9CyK0DgN1wWlwDUAT2rQ3QF0AzIoCFo6gSL2HENQWoegtT8hsviEoA6oGd1iK4AmgEZNARNSLBoOq4hSMv+DAkhhBDCdIUfW6byNSGx1zoAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndex);
export default __webpack_public_path__ + "static/media/index.bacc43b83f36d3292eb6220c9e80ecfc.svg";
export { ForwardRef as ReactComponent };